const CategoryNavigation = function() {
    const container = document.querySelector('.js-category-navigation');
    if (!container) return;

    /**
     * @param {Element} linkEl
     */
    const initializeItem = function(linkEl) {
        const menuEl = linkEl.nextElementSibling;
        if (!menuEl) return;

        const localEventHandler = (e) => {
            e.preventDefault();
            menuEl.classList.toggle('open');
        }

        if (linkEl.previousElementSibling.getAttribute('href') === '#') {
            linkEl.previousElementSibling.addEventListener('click', localEventHandler);
        }

        linkEl.addEventListener('click', localEventHandler);
    }

    const __constructor = () => {
        const subMenuLinks = document.querySelectorAll('.category-navigation__sublink');
        if (!subMenuLinks.length) return;

        subMenuLinks.forEach(link => {
            initializeItem(link);
        })
    }

    __constructor();
}

export default CategoryNavigation;
